import { Option } from "@/components/AsyncSelect/AsyncSelect";
import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";
import StoreGroupSelect from "@/components/StoreGroupSelect";
import { noop } from "@/lib/noop";
import { cn } from "@/lib/utils";
import { useCallback, useState } from "react";

interface StoreGroupFilterProps {
  inDialog?: boolean;
  className?: string;
}

const StoreGroupFilter = ({ inDialog, className }: StoreGroupFilterProps) => {
  const { options } = useDataTableSettings();

  const [value, setValue] = useState<string | undefined>(
    options.getFilterValue("store_group_id")?.value,
  );
  const [selectedItem, setSelectedItem] = useState<Option | undefined>();

  const setValueInternal = useCallback(
    (value: string, option?: Option) => {
      setValue(value);
      setSelectedItem(option);
      options.setFilterValue("store_group_id", {
        value,
      });
    },
    [options],
  );

  return (
    <div
      className={cn(
        "flex flex-row gap-2 items-center justify-center",
        className,
      )}
    >
      <StoreGroupSelect
        value={value}
        onChange={setValueInternal}
        onBlur={noop}
        name="store_group_id"
        loading="eager"
        inDialog={inDialog}
        showLink={false}
        className={cn({
          "bg-blue-100 border-blue-300 text-blue-700": value !== undefined,
        })}
        clear
        defaultItem={selectedItem}
      />
    </div>
  );
};

export default StoreGroupFilter;
